import * as React from "react";
import renderUtils from "../../../helpers/renderUtils";

const fields = (t)=> ({
    config: {columns: 1},
    fields: [
        {
            name: "machineType",
            label: t ? t("common.machine_type") : "Typ maszyny",
            column: 1,
            type: "enum",
            enumType: "enums/machineType",
            mandatory: true
        },
        {
            name: "machineModel",
            label: t ? t("common.machine_model") : "Model maszyny",
            column: 1,
            type: "dictionary",
            searchBy: function (option) {
                return option.model
            },
            useSelect: true,

            dictionary: "machineModel",
            mandatory: true,
            renderOption: (option) => <>{renderUtils.renderMachineModel(option)}</>,
            filterBy: (option, props) =>
                renderUtils.renderMachineModel(option).toLowerCase().indexOf(props.text.toLowerCase()) !== -1
            ,
            placeholder: "Wpisz model maszyny",
            conditionalOn: "machineType",
            conditionalOnNotNull: true,
            filterValues: function (dictionaries, formData, values) {
                if (formData && formData["machineType"]) {
                    return values.filter(machineModel => machineModel.machineType === formData["machineType"] )
                }
            }
        },

    ]


});

export default fields;